
















































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import * as shapeConvertService from "@/api/shape_converter/index";
import * as notificationService from "@/services/notification/index";
import i18n from "@/i18n";

@Component({
  name: "AgroFileUpload",
  components: {
    AgroIcons,
  },
})
export default class AgroFileUpload extends Vue {
  @Prop({ type: Boolean, default: false }) private isVisible!: boolean;
  private file: File | null = null;
  private geoUpload2: File | null = null;
  private isLoading: boolean | null = null;
  private response: any | undefined = undefined;
  private isFileUploadVisible: boolean = false;

  private changeFile(event: any) {
    this.file = (event as DragEvent).dataTransfer!.files[0];
  }

  private closeFileUpload() {
    this.file = null;
    this.$emit("toggle", event);
  }

  private changedFile() {
    if (this.$refs.geoUpload !== null) {
      this.file = (this.$refs.geoUpload as HTMLInputElement).files![0];
    }
  }

  private async sendGeoFile() {
    this.isLoading = true;

    if (this.file == null) return;

    try {
      this.response = await shapeConvertService.sendGeoFile(this.file!);
      this.$emit("uploadedMapFile", this.response);
    } catch (e) {
      notificationService.addErrorNotification(
        i18n.t("notifications.error.map-file-upload-error") as string
      );
    } finally {
      this.isLoading = false;
      this.file = null;
      this.$emit("toggle", event);
    }
  }
}
